import { getBeaufortIconComponent } from '../../config/beaufortIcons.config';

const BeaufortIcons = ({ conditionId }) => {
  const IconComponent = getBeaufortIconComponent(conditionId);

  return <IconComponent />;
};

export default BeaufortIcons;
